<template>
  <base-modal @close="$emit('close')" @confirm="create">
    <div class="p-6 space-y-2">
      <p class="text-center text-xl font-medium mb-4">
        Perbaharui NIK Akun Anda
      </p>
      <p class="text-sm text-gray-600">
        NIK bisa diisi juga pada halaman pengaturan.
      </p>
      <div class="form-control w-full">
        <label class="label">
          <span class="label-text">NIK</span>
        </label>
        <input
          v-sanitize
          type="text"
          placeholder="xxxxxxxxxxxxxxxx"
          class="input input-bordered w-full"
          v-model="nik"
          @input="filterNonNumeric"
        />
        <p v-if="error" class="text-red-600 text-sm mt-2">
          Nomer NIK harus 16 angka
        </p>
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "../../layout/BaseModal.vue";
import useAuthStore from "@/stores/auth";
import { mapActions } from "pinia";
export default {
  data() {
    return {
      nik: "",
      error: false,
    };
  },
  components: { BaseModal },
  methods: {
    ...mapActions(useAuthStore, ["changeNIK"]),
    async create() {
      if (this.nik.length == 16) {
        this.error = false;
        const success = await this.changeNIK(this.nik);
        success && this.$emit("close");
      } else {
        this.error = true;
      }
    },
    filterNonNumeric() {
      // Use a regular expression to filter out non-numeric characters
      this.nik = this.nik.replace(/\D/g, "");
    },
  },
};
</script>

<style></style>
